import { injectable } from 'inversify';
import 'reflect-metadata';

@injectable()
export class ClientStorageService implements IClientStorageService {
  get<T = string | object>(key: string): T | null {
    let value = localStorage.getItem(key);

    if (value === null) return null;
    try {
      return JSON.parse(value);
    } catch {
      // @ts-ignore
      return value as T;
    }
  }

  set(key: string, payload: object | string) {
    const value = typeof payload === 'object' ? JSON.stringify(payload) : payload;
    localStorage.setItem(key, value);
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }
}

export interface IClientStorageService {
  get<T = string | object>(key: string): T | null;
  set(key: string, payload: object | string): void;
  remove(key: string): void;
}
